module.exports = __webpack_public_path__ + "static/media/Akemi_6122.5f92c70f.jpg";